// @ts-nocheck
import { Box, Card, CardContent, Grid, MenuItem, Select, Typography } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import { ILaboratoryReducer } from 'Reducers/LaboratoryReducer';

interface IDashboardStats {
  dashboardStats: ILaboratoryReducer['dashboardStats'];
  dateRange: string;
  onDateRangeChange: (value: string) => void;
}

const COLORS = ['#1976d2', '#388e3c', '#f57c00', '#d32f2f', '#7b1fa2', '#00796b', '#c2185b', '#512da8'];

export default function DashboardStats(props: IDashboardStats) {
  const { dashboardStats, dateRange, onDateRangeChange } = props;

  const stats = dashboardStats || {
    statusCounts: { pending: 0, inProgress: 0, completed: 0, dispatched: 0, rejected: 0 },
    testGroupBreakdown: [],
    total: 0,
  };

  const chartData = stats.testGroupBreakdown.map((item: any, index: number) => ({
    ...item,
    fill: COLORS[index % COLORS.length],
  }));

  return (
    <Box mb={4}>
      {/* Date Filter */}
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Select
          value={dateRange}
          onChange={(e) => onDateRangeChange(e.target.value as string)}
          size="small"
          sx={{ minWidth: 180 }}
        >
          <MenuItem value="this_week">This Week</MenuItem>
          <MenuItem value="last_week">Last Week</MenuItem>
          <MenuItem value="this_month">This Month</MenuItem>
          <MenuItem value="last_month">Last Month</MenuItem>
          <MenuItem value="last_3_months">Last 3 Months</MenuItem>
        </Select>
      </Box>

      {/* Test Group Chart */}
      {chartData.length > 0 && (
        <Card variant="outlined">
          <CardContent>
            <Typography variant="subtitle1" fontWeight={600} mb={2}>
              Samples by Test Group
            </Typography>
            {/* @ts-ignore: recharts v2 type incompatibility with React 17 */}
            <ResponsiveContainer width="100%" height={300}>
              {/* @ts-ignore */}
              <BarChart data={chartData} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="testGroupName" tick={{ fontSize: 12 }} />
                <YAxis allowDecimals={false} />
                <Tooltip />
                <Bar dataKey="count" name="Samples">
                  {chartData.map((entry: any, index: number) => (
                    <Cell key={`cell-${index}`} fill={entry.fill} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      )}
    </Box>
  );
}
